import axios from "axios";

// const URL = 'https://travel-advisor.p.rapidapi.com/restaurants/list-in-boundary' ;

export const getPlacesDetails = async (type,sw,ne)=>{
    try {
        const { data : {data}} = await axios.get(`https://travel-advisor.p.rapidapi.com/${type}/list-in-boundary`,
              {
                params: {
                  bl_latitude: sw.lat,
                  tr_latitude: ne.lat,
                  bl_longitude: sw.lng,
                  tr_longitude: ne.lng,
                },
                headers: {
                  'x-rapidapi-key': process.env.REACT_APP_RAPID_API_TRAVEL_API_KEY,
                  'x-rapidapi-host': 'travel-advisor.p.rapidapi.com'
                }
              }
        );

        return data;
    } catch (error) {
        console.log(error);
    }
}


export const getWeatherData = async(lat,lng)=>{
  try {
     const { data } = await axios.get("https://community-open-weather-map.p.rapidapi.com/find",{
      params: { lon: lng, lat: lat },
      headers: {
        'x-rapidapi-key': process.env.REACT_APP_RAPID_API_WEATHER_API_KEY,
        'x-rapidapi-host': 'community-open-weather-map.p.rapidapi.com'
      }
     })
     return data;
  } catch (error) {
     console.log(error)
  }
}

/**
 * 
 * import axios from "axios";

const options = {
  method: 'GET',
  url: 'https://travel-advisor.p.rapidapi.com/attractions/list-in-boundary',
  params: {
    tr_longitude: '<REQUIRED>',
    tr_latitude: '<REQUIRED>',
    bl_longitude: '<REQUIRED>',
    bl_latitude: '<REQUIRED>',
    currency: 'USD',
    lunit: 'km',
    lang: 'en_US'
  },
  headers: {
    'x-rapidapi-key': 'c821e50a23msh4746834357f261bp17ff7djsn9dc401ef2646',
    'x-rapidapi-host': 'travel-advisor.p.rapidapi.com'
  }
};

axios.request(options).then(function (response) {
	console.log(response.data);
}).catch(function (error) {
	console.error(error);
});

 */